import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

const Faq = () => {
    const handleSubmit = event => {
        event.preventDefault();
        toast('We will contact you soon!')
    }
    return (
        <div>
            <div className="container my-24 px-6 mx-auto">
                <section className="mb-32 text-gray-800">
                    <div className="grid lg:grid-cols-2 gap-4 lg:gap-x-12 lg:mb-0">
                        <div className="mb-12 lg:mb-0">
                            <h2 className="text-3xl font-bold mb-6">Frequently asked questions</h2>

                            <p className="text-gray-500 mb-12">
                                Didn't find your answer in the FAQ? Contact our team.
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div className="form-group mb-6">
                                    <input type="text"
                                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        id="exampleInput7" placeholder="Name" />
                                </div>
                                <div className="form-group mb-6">
                                    <input type="email"
                                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        id="exampleInput8" placeholder="Email address" />
                                </div>
                                <div className="form-group mb-6">
                                    <textarea
                                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                        id="exampleFormControlTextarea13" rows="3" placeholder="Message"></textarea>
                                </div>
                                <div className="form-group form-check text-center mb-6">
                                    <input type="checkbox"
                                        className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain mr-2 cursor-pointer"
                                        id="exampleCheck87" checked />
                                </div>
                                <button type="submit"
                                    className="w-full px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                                    Send
                                </button>
                            </form>
                        </div>

                        <div className="mb-6 md:mb-0">
                            <p className="font-bold mb-4">Why you should use us ?</p>
                            <p className="text-gray-500 mb-12">
                                We are leading solution to warehouse management not only will your warehouse employees be more efficient, but everyone working with the data from the warehouse (Purchasing, Business intelligence, Sales, etc.) will have smoother, faster, and more valid dataflow.
                            </p>

                            <p className="font-bold mb-4">What we deliver ?</p>
                            <p className="text-gray-500 mb-12">
                                We are a collection of feature that provide nearly endless opportunities to accelerate growth. We accelerates startups & connect corporations to exponential technologies, business models & ideas.
                            </p>

                            <p className="font-bold mb-4">
                                Who is our competition ?
                            </p>
                            <p className="text-gray-500 mb-12">
                                YourInventory provides best-in-class modern, flexible workspace to customers including some of the most successful, entrepreneurs, individuals and multi-million dollar corporations.
                            </p>

                            <p className="font-bold mb-4">What is our Promise ?</p>
                            <p className="text-gray-500 mb-12">
                                We promise our customer, either explicitly or implicitly, what they can expect from our product or service. We will reach your expectations on the quality of our products or services.
                            </p>
                        </div>
                    </div>
                </section>

            </div>
            <ToastContainer></ToastContainer>
        </div>
    );
};

export default Faq;